export const ActionTypes = {
  TDM_SEARCH_CONTROL_INIT_SUCCESS: 'TDM_SEARCH_CONTROL_INIT_SUCCESS',
  TDM_SEARCH_CONTROL_INIT_FAIL: 'TDM_SEARCH_CONTROL_INIT_FAIL',
  TDM_SEARCH_CONTROL_CHANGE_DEPARTURE_AIRPORT: 'TDM_SEARCH_CONTROL_CHANGE_DEPARTURE_AIRPORT',
  TDM_SEARCH_CONTROL_CHANGE_DEPARTURE_DATE: 'TDM_SEARCH_CONTROL_CHANGE_DEPARTURE_DATE',
  TDM_SEARCH_CONTROL_CHANGE_ROOM_DISTRIBUTION: 'TDM_SEARCH_CONTROL_CHANGE_ROOM_DISTRIBUTION',
};
